import type { AddToTimeSelectionEvent, TimeSelectionEventData } from './AddToTimeSelectionEvent';
import type { OpenEventDetailsEventData, OpenEventDetailsEvent } from './OpenEventDetailsEvent';
import type {
    RemoveFromTimeSelectionEvent,
    RemoveTimeSelectionEventData,
} from './RemoveFromTimeSelectionEvent';

export const CalendarSidePanelEventTypes = {
    addToTimeSelection: 'addToTimeSelection',
    removeFromTimeSelection: 'removeFromTimeSelection',
    openEventDetails: 'openEventDetails',
} as const;

export type CalendarSidePanelEventUnion =
    | AddToTimeSelectionEvent
    | RemoveFromTimeSelectionEvent
    | OpenEventDetailsEvent;

export const CalendarSidePanelEvents = {
    addToTimeSelection: (
        originator: string,
        data: () => TimeSelectionEventData
    ): AddToTimeSelectionEvent => ({
        originator,
        type: CalendarSidePanelEventTypes.addToTimeSelection,
        data,
    }),
    removeFromTimeSelection: (
        originator: string,
        data: () => RemoveTimeSelectionEventData
    ): RemoveFromTimeSelectionEvent => ({
        originator,
        type: CalendarSidePanelEventTypes.removeFromTimeSelection,
        data,
    }),
    openEventDetails: (
        originator: string,
        data: () => OpenEventDetailsEventData
    ): OpenEventDetailsEvent => ({
        originator,
        type: CalendarSidePanelEventTypes.openEventDetails,
        data,
    }),
};

export type CalendarSidePanelOwaNovaEventMap = {
    addToTimeSelection: AddToTimeSelectionEvent;
    removeFromTimeSelection: RemoveFromTimeSelectionEvent;
    openEventDetails: OpenEventDetailsEvent;
};
